<div class="company-selector" (keydown.escape)="close()">
  <button
    class="company-btn"
    (click)="toggle()"
    [class.static]="!hasMultiple()"
    [attr.aria-expanded]="open()"
    aria-haspopup="true"
    aria-label="Empresa ativa"
    [title]="activeTenant()?.name ?? ''">
    <span class="company-icon" aria-hidden="true">
      <svg width="16" height="16" viewBox="0 0 18 18" fill="none"><rect x="3" y="2" width="9" height="14" stroke="currentColor" stroke-width="1.6"/><rect x="12" y="7" width="3" height="9" stroke="currentColor" stroke-width="1.6"/><line x1="5.5" y1="5" x2="5.5" y2="5.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><line x1="9" y1="5" x2="9" y2="5.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
    </span>
    <span class="company-identity">
      <span class="company-name">{{ activeTenant()?.name ?? 'Selecione a empresa' }}</span>
      @if (activeTenantDoc()) {
        <span class="company-doc">{{ activeTenantDoc() }}</span>
      }
    </span>
    @if (hasMultiple()) {
      <svg class="chevron" [class.open]="open()" width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
        <path d="M3 5L7 9L11 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    }
  </button>

  @if (open()) {
    <div class="menu-backdrop" (click)="close()" aria-hidden="true"></div>

    <div class="company-dropdown" role="menu" aria-label="Selecionar empresa">
      <ul class="company-list" role="none">
        @for (option of options(); track option.id) {
          <li role="none">
            <button
              class="company-option"
              [class.active]="option.id === activeTenant()?.id"
              role="menuitemradio"
              [attr.aria-checked]="option.id === activeTenant()?.id"
              (click)="select(option)">
              <span class="company-option-name">{{ option.name }}</span>
              @if (option.cpfCnpj) {
                <span class="company-option-doc">{{ formatDoc(option.cpfCnpj) }}</span>
              }
            </button>
          </li>
        }
      </ul>
    </div>
  }
</div>
